module.exports = __webpack_public_path__ + "static/media/cimg1.8d94291b.jpg";